<template>
    <div class="space-y-6">
        <!-- Form fields -->
        <div v-for="n in fieldCount" :key="n" class="space-y-2">
            <!-- Field label skeleton -->
            <SkeletonLoader class="h-4 w-24" />
            <!-- Field input skeleton -->
            <SkeletonLoader class="h-10 w-full" />
        </div>
        
        <!-- Advanced section skeleton (if needed) -->
        <div v-if="showAdvanced" class="mt-8">
            <!-- Advanced toggle skeleton -->
            <SkeletonLoader class="h-12 w-full rounded-lg" />
        </div>
    </div>
</template>

<script setup>
import { SkeletonLoader } from './index';

const props = defineProps({
    fieldCount: {
        type: Number,
        default: 6
    },
    showAdvanced: {
        type: Boolean,
        default: true
    }
});
</script>